module.exports = __webpack_public_path__ + "img/edit-orange.45014bc7.svg";